import { measureTextWidth } from "./measure-text-width";

const CHIP_FONT = "500 14px Roboto, Helvetica, Arial, sans-serif";
// Chip's own label padding plus the px:1 we add in Badge, plus a safety
// buffer for font-metric rounding, so the "Review Status" badge never gets
// clipped at its measured width.
const CHIP_HORIZONTAL_CHROME_PX = 64;
const MIN_STATUS_BADGE_COLUMN_WIDTH_PX = 90;
const MAX_STATUS_BADGE_COLUMN_WIDTH_PX = 260;

/** Sizes a sticky status-badge column to fit the widest label currently on screen, so it hugs the Open button when labels are short. */
export const getStatusBadgeColumnWidth = (
  labels: (string | undefined)[]
): number => {
  const longestLabelWidth = Math.max(
    0,
    ...labels
      .filter((label): label is string => Boolean(label))
      .map((label) => measureTextWidth(label, CHIP_FONT))
  );

  const width = Math.round(longestLabelWidth + CHIP_HORIZONTAL_CHROME_PX);

  return Math.min(
    MAX_STATUS_BADGE_COLUMN_WIDTH_PX,
    Math.max(MIN_STATUS_BADGE_COLUMN_WIDTH_PX, width)
  );
};
